import { Classification } from '@/store/classificationsApi';
import CategoryUtility, { ClassificationItem } from '../categories.utility';
import { ClassificationIds } from '@/utils/enums';
import { useMemo, useState } from 'react';

const useExpandableList = (classifications: Classification[]) => {
  const getLiabilityName = (classifications: Classification[]): string => {
    return (
      classifications.find(
        (x) => x.ClassificationId === ClassificationIds.LIABILITY,
      )?.Name || 'Liabilities'
    );
  };

  const getAssetName = (classifications: Classification[]): string => {
    return (
      classifications.find(
        (x) => x.ClassificationId === ClassificationIds.ASSET,
      )?.Name || 'Assets'
    );
  };

  /**
   * Open "Assets" and "Liabilities" by default.
   */
  const [openCategories, setOpenCategories] = useState<Record<string, boolean>>(
    {
      [getAssetName(classifications)]: true,
      [getLiabilityName(classifications)]: true,
    },
  );

  const [selectedClassification, setSelectedClassification] =
    useState<ClassificationItem | null>(null);

  const handleClassificationClick = (
    classification: ClassificationItem | null,
  ) => {
    setSelectedClassification(classification);
  };

  const accountTypes = useMemo(() => {
    return CategoryUtility.categorize({
      classifications,
      label: {
        asset: getAssetName(classifications),
        liability: getLiabilityName(classifications),
      },
    });
  }, [classifications]);

  const handleCategoryClick = (categoryName: string) => {
    setOpenCategories((prev) => ({
      ...prev,
      [categoryName]: !prev[categoryName],
    }));
  };

  return {
    accountTypes,
    openCategories,
    handleCategoryClick,
    selectedClassification,
    handleClassificationClick,
  };
};

export default useExpandableList;
